// Lightweight, dependency-free password strength estimator for signup/reset UI.
// Returns a score 0-4 with a human label and a token-driven color class.
// This is a UX HINT ONLY — the backend remains the source of truth for validation.

export function passwordStrength(pw = '') {
  const p = String(pw);
  if (!p) return { score: 0, label: '', percent: 0, colorClass: 'bg-muted', valid: false };

  let score = 0;
  const checks = {
    length8: p.length >= 8,
    length12: p.length >= 12,
    lower: /[a-z]/.test(p),
    upper: /[A-Z]/.test(p),
    number: /\d/.test(p),
    symbol: /[^A-Za-z0-9]/.test(p),
  };
  const variety = [checks.lower, checks.upper, checks.number, checks.symbol].filter(Boolean).length;

  if (checks.length8) score += 1;
  if (checks.length12) score += 1;
  if (variety >= 2) score += 1;
  if (variety >= 3) score += 1;
  // Penalise very short passwords regardless of variety.
  if (p.length < 6) score = Math.min(score, 1);
  score = Math.max(0, Math.min(4, score));

  const META = [
    { label: 'Very weak', colorClass: 'bg-destructive' },
    { label: 'Weak', colorClass: 'bg-destructive' },
    { label: 'Fair', colorClass: 'bg-amber-500' },
    { label: 'Good', colorClass: 'bg-lime-500' },
    { label: 'Strong', colorClass: 'bg-emerald-500' },
  ];
  const meta = META[score];
  return {
    score,
    label: meta.label,
    colorClass: meta.colorClass,
    percent: (score / 4) * 100,
    checks,
    // Minimum acceptable for signup/reset: 8+ chars with at least a letter and a number.
    valid: p.length >= 8 && /[A-Za-z]/.test(p) && /\d/.test(p),
  };
}

export const PasswordStrengthMeter = null; // (UI lives in components/PasswordStrengthMeter.js)
